import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { CommonService } from 'src/app/shared/services/common.service';
import { SideMenuService } from 'src/app/shared/side-menu/side-menu.service';
import * as moment from 'moment';
import { SiteDashboardService } from 'src/app/home/site-dashboard/site-dashboard.service';
import { AngularCsv } from 'angular-csv-ext/dist/Angular-csv';
@Component({
	selector: 'app-site-batteries-reports',
	templateUrl: './site-batteries-reports.component.html',
	styleUrls: ['./site-batteries-reports.component.css']
})
export class SiteBatteriesReportsComponent implements OnInit, OnDestroy {
	siteSub : Subscription = new Subscription();
	siteInfo: any = {};

	maxDate = new Date((new Date()).getTime() - 24 * 60 * 60 * 1000); // yesterday
	toDate = this.maxDate; // yesterday
	fromDate = new Date((new Date()).getTime() - 30 * 24 * 60 * 60 * 1000); // 30 days ago
	minDate = this.fromDate;

	batteryVoltagesOptions: any[] = [];
	selectedBatteryVoltage: string = 'all';

	batteryCapacitiesOptions: any[] = [];
	selectedBatteryCapacity: string = 'all';

	vintageOptionsDropdown = this.siteDashboardService.vintageOptionsDropdown;
	selectedBatteryVintage: string[] = ['all'];

	batteryManufacturersOptions: any[] = [];
	selectedBatteryManufacturer: string = 'all';

	chartOrder = [
		'inuse_end_voltage',
		'charge_end_voltage',
		'soc_distribution',
		'charging_temp_distribution',
		'inuse_temp_distribution',
		'plug_in_distribution',
	];

	chartsData: Map<string, {
		title: string;
		xAxisLabel: string;
		yAxisLabel: string;
		data: any[];
		totalEventsCount: number
	}> = new Map();

	get printFilters(): { label: string, value: string }[] {
		return [
			{ label: 'perf_analytic.period', value: `${moment(this.fromDate).format('MM/DD/YYYY')} - ${moment(this.toDate).format('MM/DD/YYYY')}` },
			{ label: 'fleet_reports.battery_voltage', value: this.commonService.getOptionLabel(this.batteryVoltagesOptions, this.selectedBatteryVoltage) },
			{ label: 'devices.battery_capacity', value: this.commonService.getOptionLabel(this.batteryCapacitiesOptions, this.selectedBatteryCapacity) },
			{ label: 'devices.battery_manufacturer', value: this.commonService.getOptionLabel(this.batteryManufacturersOptions, this.selectedBatteryManufacturer) },
			{ label: 'devices.battery_vintage', value: this.commonService.getOptionLabel(this.vintageOptionsDropdown, this.selectedBatteryVintage) }
		];
	}

	constructor(
		private commonService: CommonService,
		private translateService: TranslateService,
		private sideMenuService: SideMenuService,
		private siteDashboardService: SiteDashboardService,
	){}

	ngOnInit() {
		this.siteSub = this.sideMenuService.currentSite.subscribe((site) => {
			if (!site || !site['id'])
				return;
			this.siteInfo = site;
			this.commonService.setPageTabTitle(`${site['customer_name']} - ${site['name']} - ${this.translateService.instant('fleet_reports.site_batteries_reports')}`);

			if (this.siteInfo.installation_date) {
				this.minDate = moment.utc(this.siteInfo.installation_date).startOf('day').toDate();
			}
		});
	}

	onChartDataReady(key: string, event: { title: string, xAxisLabel: string, yAxisLabel: string, data: any[], totalEventsCount: number }) {
		this.chartsData.set(key, event);
	}

	prepareParentFiltersOptions(event: { batteryVoltagesOptions: any[], batteryCapacitiesOptions: any[], batteryManufacturersOptions: any[] }) {
		this.batteryVoltagesOptions.push(...event.batteryVoltagesOptions);
		this.batteryCapacitiesOptions.push(...event.batteryCapacitiesOptions);
		this.batteryManufacturersOptions.push(...event.batteryManufacturersOptions);

		this.batteryVoltagesOptions = [...new Map(this.batteryVoltagesOptions.map(i => [i.value, i])).values()];
		this.batteryCapacitiesOptions = [...new Map(this.batteryCapacitiesOptions.map(i => [i.value, i])).values()];
		this.batteryManufacturersOptions = [...new Map(this.batteryManufacturersOptions.map(i => [i.value, i])).values()];
	}

	batteryVintageSelectionChanged() {
		if (!this.selectedBatteryVintage.length)
			this.selectedBatteryVintage = [this.siteDashboardService.vintageOptionsDropdown[0].value];

		if (this.selectedBatteryVintage.length > 1 && this.selectedBatteryVintage.includes(this.siteDashboardService.vintageOptionsDropdown[0].value)) {
			if (this.selectedBatteryVintage[0] == this.siteDashboardService.vintageOptionsDropdown[0].value)
				this.selectedBatteryVintage = this.selectedBatteryVintage.filter(value => value !== this.siteDashboardService.vintageOptionsDropdown[0].value);
			else
				this.selectedBatteryVintage = [this.siteDashboardService.vintageOptionsDropdown[0].value];
		}
	}

	exportDataToCsv() {
		const headersInfo = this.commonService.getCsvFileHeadersInfo({
			customerName: this.siteInfo.customer_name,
			siteName: this.siteInfo.name,
		});

		const csvData = [...headersInfo];

		for (const key of this.chartOrder) {
			const chart = this.chartsData.get(key);
			if (!chart)
				continue;

			csvData.push([chart.title]);

			if (chart.totalEventsCount > 0 && chart.data?.length) {

				csvData.push([chart.xAxisLabel, chart.yAxisLabel]);

				for (const row of chart.data) {
					csvData.push([row[0], row[1]]);
				}
			}
			csvData.push([]);
		}

		new AngularCsv(csvData, this.translateService.instant('fleet_reports.battery_performance_charts'));
	}

	ngOnDestroy() {
		if (this.siteSub)
			this.siteSub.unsubscribe();
	}
}
